<template>
  <div v-if="!notificationStatus == 1" class="item" @click="requestNotification">
    <i class="la la-bell font-h3"></i>
    <h6 class="flex-1 mb-0 px-10">Enable desktop notifications</h6>
    <div class="button-round bg-primary">
      <i class="la la-mouse-pointer"></i>
    </div>
    <span class="shimmer"></span>
  </div>
</template>

<script>
import request from "@/service";
// import { getToken } from "firebase/messaging";
import { getBrowser } from "@/helpers/functions";
// import firebaseMessaging from "@/firebase";
export default {
  name: "Notification-Bar",
  components: {},
  props: {},
  data: function () {
    return {
      notificationStatus: -1,
    };
  },
  watch: {
    notificationStatus: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit("updateStatus", this.notificationStatus);
      },
    },
  },
  async mounted() {
    setTimeout(() => {
      if (Notification.permission == "granted") {
        this.notificationStatus = 1;
        this.registerToken();
      } else {
        this.notificationStatus = 0;
      }
    }, 1000);
  },
  methods: {
    requestNotification() {
      try {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            this.registerToken();
            this.notificationStatus = 1;
            this.$root.$emit("milestone-notification-alert", "enable_notifications");
          }
        });
      } catch {}
    },
    registerToken() {
      try {
        const { getToken, getMessaging, onMessage } = require("firebase/messaging");
        const { initializeApp } = require("firebase/app");
        const firebaseConfig = {
          apiKey: "AIzaSyA6wOpaUx5_9aX2dW_9b0qUjRXOuoWbbu8",
          authDomain: "tuan-callendo.firebaseapp.com",
          projectId: "tuan-callendo",
          storageBucket: "tuan-callendo.appspot.com",
          messagingSenderId: "863031227200",
          appId: "1:863031227200:web:d8c5cb6db6c389ca6740a5",
          measurementId: "G-1VPJ6CNB51",
        };

        const app = initializeApp(firebaseConfig);

        const messaging = getMessaging(app);
        onMessage(messaging, (payload) => {
          // Customize notification here
          const title = payload.data.title;
          const options = {
            body: payload.data.body,
          };

          if (payload.data.link) {
            options.data = {
              link: payload.data.link,
            };
          }
          if (payload.data.canvas != "") {
            options.icon = payload.data.canvas;
          }
          if (payload.data.image != "") {
            options.image = payload.data.image;
          }

          if (document.visibilityState === "visible") {
            var notification = new Notification(title, options);
            notification.onclick = function () {
              if (payload.data.link) {
                window.open(payload.data.link);
              }
            };
          }

          // self.registration.showNotification(title, options);
        });

        // const firebaseMessaging = require("@/firebase");
        // console.log(firebaseMessaging);
        getToken(messaging, {
          vapidKey: "BKS5Fn3_uJY7O-OiPVvnGYCOC2L_AZLc6rRYToFicerjIYrRcX4CMyFuJDrZ-Qxg7dOUf8Hf2Fd-AnJmdmGQ67I",
        })
          .then((currentToken) => {
            if (currentToken) {
              let device_info = getBrowser();
              let userID = this.$store.getters.getMe.userID;
              request("POST", "notification/registerToken", {
                user_id: userID,
                fcm_token: currentToken,
                platform: "web",
                device_info: device_info,
              });
            } else {
              console.log("No registration token available. Request permission to generate one.");
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
